import { render, staticRenderFns } from "./FormInputStandardUserSendDocumentsFunction.vue?vue&type=template&id=05ea93aa&scoped=true&lang=pug"
import script from "./FormInputStandardUserSendDocumentsFunction.vue?vue&type=script&lang=ts"
export * from "./FormInputStandardUserSendDocumentsFunction.vue?vue&type=script&lang=ts"
import style0 from "./FormInputStandardUserSendDocumentsFunction.vue?vue&type=style&index=0&id=05ea93aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea93aa",
  null
  
)

export default component.exports